import { toggleTree } from "./toggling";

const addTreeRows = (tableName, data, ms, doc, path = "") => {
	const name = doc.label || doc.title || "(нет имени)";

	data.addRow(ms, tableName, {
		key: doc._id,
		list: [
			"",
			doc._id,
			path,
			name,
			(doc.children || []).map((el) => el._id),
			doc.type,
			doc.formId,
		],
	});

	for (const childDoc of doc.children || [])
		addTreeRows(
			tableName,
			data,
			ms,
			childDoc,
			path ? `${path}/${name}` : name,
			doc.type,
			doc.formId,
		);
};

export const loadTrees = (tableName, trees, data, ms) => {
	const table = data.curData.values.table[tableName];
	data.delList(tableName);
	for (const doc of trees) addTreeRows(tableName, data, ms, doc);
	const excluded = data.curData.values.fld.data;
	for (const row of table.list)
		if (excluded.includes(row.key))
			toggleTree(tableName, data, table.list, row, true);
};
